import './PublicDashboardSecondStep.scss';
import useTermsAndConditions from '../../hooks/useTermsAndConditions';
import TermsAndConditionsModal from '../TermsAndConditionsModal/TermsAndConditionsModal';
import AccessInput from '../AccessInput/AccessInput';
import HorizontalLoader from '../HorizontalLoader/HorizontalLoader';
import OTPInputCodePassword from '../OTPInputCodePassword/OTPInputCodePassword';
import { t } from '../../i18n/i18n';
import { colors } from '../../constants/colors';
import { Platforms } from '../../constants/enums';
import DebouncedButton from '../Button/Button';

const PublicDashboardSecondStep = ({
  isNewUser,
  userData,
  setUserData,
  focusName,
  setFocusName,
  focusLastName,
  setFocusLastName,
  codeOTP,
  setCodeOTP,
  handleAcceptDashboardInvitation,
  loading,
}) => {
  const { acceptedTermsAndConditions, setAcceptedTermsAndConditions } = useTermsAndConditions(
    Platforms.PARTNERS
  );

  const isButtonDisabled =
    loading ||
    codeOTP.some((codeChar) => codeChar.trim() === '') ||
    (isNewUser && [userData.name, userData.lastName].some((field) => field.trim() === ''));

  return (
    <div className="w-100 d-flex flex-column gap-2">
      {loading ? (
        <div className="d-flex justify-content-center my-4">
          <HorizontalLoader className="no-height" />
        </div>
      ) : (
        <>
          {isNewUser && (
            <div className="d-flex flex-column flex-md-row gap-3">
              <AccessInput
                value={userData.name}
                onFocus={() => setFocusName(true)}
                onBlur={() => setFocusName(false)}
                onChange={(e) => setUserData({ ...userData, name: e.target.value })}
                focus={focusName}
                placeholder={t('PUBLIC_DASHBOARD_INPUT_NAME_PLACEHOLDER')}
                withoutLogo
              />
              <AccessInput
                value={userData.lastName}
                onFocus={() => setFocusLastName(true)}
                onBlur={() => setFocusLastName(false)}
                onChange={(e) => setUserData({ ...userData, lastName: e.target.value })}
                focus={focusLastName}
                placeholder={t('PUBLIC_DASHBOARD_INPUT_LASTNAME_PLACEHOLDER')}
                withoutLogo
              />
            </div>
          )}
          <OTPInputCodePassword codeOTP={codeOTP} setCodeOTP={setCodeOTP} />
          {isNewUser && (
            <TermsAndConditionsModal
              acceptedTermsAndConditions={acceptedTermsAndConditions}
              setAcceptedTermsAndConditions={setAcceptedTermsAndConditions}
            />
          )}
        </>
      )}
      <DebouncedButton
        style={{
          backgroundColor: isButtonDisabled ? colors.lightGrayAlkemy : colors.lightBlue,
          cursor: isButtonDisabled ? 'not-allowed' : 'pointer',
        }}
        className={`d-flex align-items-center justify-content-center text-white fw-semibold px-3 py-2 rounded transition-colors ${
          isButtonDisabled ? '' : 'btn-hover-brightness'
        }`}
        disabled={isButtonDisabled}
        onClick={handleAcceptDashboardInvitation}
        debounceTime={500}
        onMouseOver={(e) => {
          if (!isButtonDisabled) e.currentTarget.style.backgroundColor = colors.blueAlkemy;
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = isButtonDisabled
            ? colors.lightGrayAlkemy
            : colors.lightBlue;
        }}
        onFocus={(e) => {
          if (!isButtonDisabled) e.currentTarget.style.backgroundColor = colors.blueAlkemy;
        }}
        onBlur={(e) => {
          e.currentTarget.style.backgroundColor = isButtonDisabled
            ? colors.lightGrayAlkemy
            : colors.lightBlue;
        }}
      >
        {t('PUBLIC_DASHBOARD_CONFIRM_CODE')}
      </DebouncedButton>
    </div>
  );
};

export default PublicDashboardSecondStep;
